import {useMutation, useQuery, useQueryClient} from "react-query"
import {NoneOperationCommentApi as commentApi} from "api/none-operation.api"
import {NotificationType, showNotification} from "common/Notification"
import {AxiosError} from "axios"
import {ApiResponse} from "api/common/response"
import {NoneOperationComment} from "dto/realdevice/none-operation-comment"

export const useFindAllNoOperCommentByEui = (eui: string, page: number, size: number) => {
    return useQuery(["none-oper-comment/list", eui, page, size], async () => {
        const result = await commentApi.findAllNoneOperCommentByEui(eui, page, size)
        return result?.data?.body
    }, {
        refetchOnMount: true,
        enabled: !!eui,
        cacheTime: 0,
    })
}

export const useFindNoOperCommentById= (id: number) => {
    return useQuery(["none-oper-comment/id", id], async () => {
        const result = await commentApi.findNoneOperCommentById(id)
        return result?.data?.body
    }, {
        refetchOnMount: true,
        enabled: !!id,
        cacheTime: 0,
        refetchInterval: false
    })
}

export const useRegisterComment = () => {
    const client = useQueryClient()
    return useMutation(async (param: NoneOperationComment) => {

        await commentApi.createNoneOperComment(param.eui, param.fromDate, param.endDate, param.comment)
        await client.invalidateQueries(["none-oper-comment/list", param.eui, 0, 10])
    }, {
        onSuccess: async (res) => {
            showNotification("사유가 등록되었습니다", NotificationType.SUCCESS)
        },
        onError: (error, variables, context) => {
            try {
                const err = error as AxiosError<ApiResponse<null>>
                showNotification(err.response?.data?.message || "등록중 오류가 발생하였습니다")
            } catch (err) {
                showNotification("등록중 오류가 발생하였습니다")
            }
        }
    })
}

export const useUpdateComment = () => {
    const client = useQueryClient()
    return useMutation(async (param: NoneOperationComment) => {

        if(!param.id) throw new Error("id가 없습니다")
        await commentApi.updateNoneOperComment(param.id, param.eui, param.fromDate, param.endDate, param.comment)
        await client.invalidateQueries(["none-oper-comment/list", param.eui, 0, 10])
    }, {
        onSuccess: async (res) => {
            showNotification("사유가 수정되었습니다", NotificationType.SUCCESS)
        },
        onError: (error, variables, context) => {
            try {
                const err = error as AxiosError<ApiResponse<null>>
                showNotification(err.response?.data?.message || "수정중 오류가 발생하였습니다")
            } catch (err) {
                showNotification("등록중 오류가 발생하였습니다")
            }
        }
    })
}

export const useDeleteCommentMutation = () => {
    const client = useQueryClient()
    return useMutation((id: number) => {
        return commentApi.deleteNoneOperComment(id)
    }, {
        onSuccess: async () => {
            await client.invalidateQueries("none-oper-comment/list")
            showNotification("사유가 삭제되었습니다", NotificationType.SUCCESS)
        },
        onError: (error,) => {
            try {
                const err = error as AxiosError<ApiResponse<null>>
                showNotification(err.response?.data?.message || "사유 삭제중 오류가 발생하였습니다")
            } catch (err) {
                showNotification("사유 삭제중 오류가 발생하였습니다")
            }
        }
    })
}